<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-alert-octagon`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 16.13a2 2 0 00-.586-1.414l-11.13-11.13A2 2 0 0031.87 3H16.13a2 2 0 00-1.414.586l-11.13 11.13A2 2 0 003 16.13v15.74a2 2 0 00.586 1.414l11.13 11.13A2 2 0 0016.13 45h15.74a2 2 0 001.414-.586l11.13-11.13A2 2 0 0045 31.87V16.13zM16.883 6.818h14.234l10.065 10.065v14.234L31.117 41.182H16.883L6.818 31.117V16.883L16.883 6.818zM22.482 14a1 1 0 011-1h2.001a1 1 0 011 1v13.001a1 1 0 01-1 1h-2.001a1 1 0 01-1-1V14zm1.368 17.002c-.76 0-1.375.616-1.375 1.375v1.375c0 .76.615 1.375 1.375 1.375h1.375c.759 0 1.375-.615 1.375-1.375v-1.375c0-.76-.616-1.375-1.375-1.375H23.85z"/></svg>
</template>
<script>

export default {
  name: 'IconAlertOctagon',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
